<template><v-container><h1>Notifications</h1></v-container></template>
<script>
export default {
  name: 'NotificationsView'}
</script>